<template>
  <section class="payment-cycle-section">
    <div class="payment-cycle-section__explanation">
      <h4 class="payment-cycle-section__title">
        {{ $tc('common.billing.paymentCycle') }}
      </h4>

      <!-- SP用の画像-->
      <img
        v-if="paymentCycleImgPath.sp"
        class="payment-cycle-section__img payment-cycle-section__img--sp"
        :src="require(`@/assets/img/${paymentCycleImgPath.sp}`)"
        alt=""
      />
      <!-- PC用の画像-->
      <img
        v-if="paymentCycleImgPath.pc"
        class="payment-cycle-section__img payment-cycle-section__img--pc"
        :src="require(`@/assets/img/${paymentCycleImgPath.pc}`)"
        alt=""
      />

      <ul class="payment-cycle-section__attentions" v-html="attention" />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import StoreUtil from '@/store/StoreUtil'
import DeviceInfo from '@/util/DeviceInfo'

/**
 * 請求サイクル画像パス（URL）の型
 */
export type PaymentCycleImgPathType = {
  pc: string
  sp: string
}

/**
 * プラン: お支払いサイクル セクション
 */
export default defineComponent({
  name: 'PaymentCycleSection',
  props: {
    /**
     * 請求サイクル画像パス
     */
    paymentCycleImgPath: {
      type: Object as PropType<PaymentCycleImgPathType>,
      required: true,
    },
    /**
     * 注意メッセージ
     */
    attention: {
      type: String,
      default: '',
    },
  },
  setup() {
    const userStore = StoreUtil.useStore('UserStore')
    const { user } = userStore

    const userLang = user.value.lang || DeviceInfo.getLanguage()

    return {
      userLang,
    }
  },
})
</script>

<style lang="scss" scoped>
.payment-cycle-section {
  width: 100%;
  padding: 0 16px;
  text-align: center;

  &__explanation {
    padding-top: 24px;
    border-top: 1px solid $black10;
  }

  &__title {
    margin-bottom: 24px;
    font-weight: 500;
    font-size: 17px;
    line-height: 1.41;
    text-align: center;
    letter-spacing: 0.02em;
    font-feature-settings: 'palt' on;
    color: $gray75;
  }

  &__img {
    width: min(100%, 768px);
    margin: 0 auto 24px;

    &--pc {
      display: block !important;
    }

    &--sp {
      display: none !important;
      max-width: 480px;
    }

    @media screen and (max-width: $responsiveTabletWidth) {
      &--pc {
        display: none !important;
      }

      &--sp {
        display: block !important;
      }
    }
  }

  &__attentions {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    align-content: flex-start;
    justify-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    max-width: 768px;
    margin: 0 auto 24px;
    text-align: left;
    @include fontSetTextMedium(13);
  }
}
</style>

<style lang="scss">
.payment-cycle-section {
  &__attentions {
    li {
      margin-left: 14px;
      text-indent: -7px;

      &:not(:last-of-type) {
        margin-bottom: 8px;
      }

      &::before {
        display: inline-block;
        content: '●';
      }

      strong {
        color: $red;
        font-weight: 500;
      }
    }
  }
}
</style>
